import { Popover as RadixPopover } from '@radix-ui/themes'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

type PopoverSize = '1' | '2' | '3' | '4'

interface PopoverContentProps
  extends Omit<ComponentPropsWithoutRef<typeof RadixPopover.Content>, 'size'> {
  size?: PopoverSize
}

const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(
  ({ size = '2', className = '', ...props }, ref) => {
    return (
      <RadixPopover.Content
        className={className}
        ref={ref}
        size={size}
        {...props}
      />
    )
  }
)

PopoverContent.displayName = 'Popover.Content'

export const Popover = {
  Root: RadixPopover.Root,
  Trigger: RadixPopover.Trigger,
  Content: PopoverContent,
  Close: RadixPopover.Close
}
